// Navigation scroll effect
window.addEventListener("scroll", () => {
  const nav = document.getElementById("navigation")
  if (window.scrollY > 50) {
    nav.classList.add("scrolled")
  } else {
    nav.classList.remove("scrolled")
  }
})

// Mobile menu toggle
const mobileMenuBtn = document.getElementById("mobileMenuBtn")
const mobileMenu = document.getElementById("mobileMenu")

mobileMenuBtn.addEventListener("click", () => {
  mobileMenu.classList.toggle("open")

  // Animate hamburger menu
  const hamburgers = mobileMenuBtn.querySelectorAll(".hamburger")
  if (mobileMenu.classList.contains("open")) {
    hamburgers[0].style.transform = "rotate(45deg) translate(5px, 5px)"
    hamburgers[1].style.opacity = "0"
    hamburgers[2].style.transform = "rotate(-45deg) translate(7px, -6px)"
  } else {
    hamburgers[0].style.transform = "none"
    hamburgers[1].style.opacity = "1"
    hamburgers[2].style.transform = "none"
  }
})

// Close mobile menu when clicking on links
document.querySelectorAll(".mobile-link").forEach((link) => {
  link.addEventListener("click", () => {
    mobileMenu.classList.remove("open")
    const hamburgers = mobileMenuBtn.querySelectorAll(".hamburger")
    hamburgers[0].style.transform = "none"
    hamburgers[1].style.opacity = "1"
    hamburgers[2].style.transform = "none"
  })
})

// Smooth scroll for navigation links
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault()
    const target = document.querySelector(this.getAttribute("href"))
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
  })
})

// Scroll to story function
function scrollToStory() {
  document.getElementById("story").scrollIntoView({
    behavior: "smooth",
  })
}

// Intersection Observer for fade-in animations
const observerOptions = {
  threshold: 0.3,
  rootMargin: "0px 0px -50px 0px",
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("visible")
    }
  })
}, observerOptions)

// Observe elements for fade-in animation
document.querySelectorAll(".fade-in-up").forEach((el) => {
  observer.observe(el)
})

// Counter animation for impact numbers
function animateCounter(element, target, duration = 2000) {
  const start = 0
  const startTime = performance.now()

  function updateCounter(currentTime) {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    const current = Math.floor(progress * target)
    element.textContent = current.toLocaleString()

    if (progress < 1) {
      requestAnimationFrame(updateCounter)
    }
  }

  requestAnimationFrame(updateCounter)
}

// Impact counter observer
const impactObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const counters = entry.target.querySelectorAll(".impact-number")
        counters.forEach((counter) => {
          const target = Number.parseInt(counter.dataset.target)
          animateCounter(counter, target)
        })
        impactObserver.unobserve(entry.target)
      }
    })
  },
  { threshold: 0.5 },
)

// Observe impact section
const impactSection = document.getElementById("impact")
if (impactSection) {
  impactObserver.observe(impactSection)
}

// Add loading animation to buttons
document.querySelectorAll(".btn").forEach((btn) => {
  btn.addEventListener("click", function (e) {
    // Add ripple effect
    const ripple = document.createElement("span")
    const rect = this.getBoundingClientRect()
    const size = Math.max(rect.width, rect.height)
    const x = e.clientX - rect.left - size / 2
    const y = e.clientY - rect.top - size / 2

    ripple.style.width = ripple.style.height = size + "px"
    ripple.style.left = x + "px"
    ripple.style.top = y + "px"
    ripple.classList.add("ripple")

    this.appendChild(ripple)

    setTimeout(() => {
      ripple.remove()
    }, 600)
  })
})

// Add ripple effect styles
const style = document.createElement("style")
style.textContent = `
    .btn {
        position: relative;
        overflow: hidden;
    }
    
    .ripple {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        transform: scale(0);
        animation: ripple-animation 0.6s linear;
        pointer-events: none;
    }
    
    @keyframes ripple-animation {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }
`
document.head.appendChild(style)

// Parallax effect for hero section
window.addEventListener("scroll", () => {
  const scrolled = window.pageYOffset
  const heroImage = document.querySelector(".hero-image")
  if (heroImage) {
    heroImage.style.transform = `translateY(${scrolled * 0.5}px)`
  }
})

// Add smooth reveal animation for cards
const cardObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }, index * 100)
      }
    })
  },
  { threshold: 0.1 },
)

// Observe all cards
document.querySelectorAll(".impact-card, .product-card, .testimonial-card").forEach((card, index) => {
  card.style.opacity = "0"
  card.style.transform = "translateY(20px)"
  card.style.transition = "opacity 0.6s ease, transform 0.6s ease"
  cardObserver.observe(card)
})